import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

const REDIRECT_RULES: [RegExp, string][] = [
  [/(stratego|imperium).*(pos-paizetai|how-to-play|kanones|odigies)/i, "/imperium1800/pos-paizetai"],
  [/(stratego|imperium).*stratigeio\/setup/i, "/imperium1800/stratigeio/setup"],
  [/(stratego|imperium).*stratigeio/i, "/imperium1800/stratigeio"],
  [/(stratego|imperium).*(lobby|prothalamos)/i, "/imperium1800/lobby"],
  [/(stratego|imperium).*(shop|katastima)/i, "/imperium1800/shop"],
  [/(stratego|imperium).*(settings|ry8miseis|rythmiseis)/i, "/imperium1800/settings"],
  [/(stratego|imperium).*(play|game|paixnidi)/i, "/imperium1800/play"],
  [/stratego|στρατεγκο|imperium|1800/i, "/imperium1800"],

  [/(tavli|backgammon).*(odigoi|odigies|kanones|οδηγι|κανον|how-to-play|pos-paizetai)/i, "/tavli-kanones"],
  [/tavli|backgammon|portes|plakoto|fevga/i, "/tavli"],
  [/ludo|griniaris/i, "/ludo"],
  [/hangman|kremala/i, "/hangman"],
  [/kseri|xeri|ξερη|ξερή/i, "/kseri"],
  [/katataxi|ranking|rank|βαθμίδ|leaderboard-info/i, "/info-leaderboard"],
];

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname.toLowerCase();

    for (const [pattern, target] of REDIRECT_RULES) {
      if (pattern.test(path)) {
        const targetLower = target.toLowerCase();
        if (path === targetLower || path + "/" === targetLower || path === targetLower + "/") {
          navigate("/", { replace: true });
          return;
        }
        navigate(target, { replace: true });
        return;
      }
    }
    // Fallback: redirect to home
    navigate("/", { replace: true });
  }, [location.pathname, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <p className="text-sm text-muted-foreground">Ανακατεύθυνση...</p>
      </div>
    </div>
  );
};

export default NotFound;
